<form #personalStage [formGroup]="personalForm" id="personalStage">

  <div class="row">
    <section class="data-field step-1 order-xl-0 col-xl-4 first-name">
      <div class="label">
        <div [innerHTML]="'firstName' | translate | translateCut:0 | safe:'html'"></div>
        <span class="small">{{ 'firstName' | translate | translateCut:1 }}</span>
      </div>
      <mat-form-field [floatLabel]="'never'" appearance="outline">
        <input (change)="onFirstNameChanged()" class="ltr-text"
               formControlName="firstName" matInput
               name="firstname" oninput="this.value=this.value.replace(/[^a-zA-Z|-\s]/g,'')">
        <mat-error *ngIf="isRequiredField('firstName')">
          {{ 'firstNameRequired' | translate }}
        </mat-error>
      </mat-form-field>
    </section>

    <section class="data-field step-1 order-xl-0 col-xl-4">
      <div class="label">
        <div [innerHTML]="'lastName' | translate | translateCut:0 | safe:'html'"></div>
        <span class="small">{{ 'lastName' | translate | translateCut:1 }}</span>
      </div>

      <mat-form-field [floatLabel]="'never'" appearance="outline">
        <input (change)="onLastNameChanged()" class="ltr-text"
               formControlName="lastName" matInput
               name="lastname" oninput="this.value=this.value.replace(/[^a-zA-Z|-\s]/g,'')">
        <mat-error *ngIf="isRequiredField('lastName')">
          {{ 'lastNameRequired' | translate }}
        </mat-error>
      </mat-form-field>
    </section>

    <section class="col-lg-12 step-2 order-xl-0 col-xl-4">
      <div class="date">
        <app-data-picker (dateChanged)="onDateChanged()" [(dateDay)]="dateDay"
                         [(dateMonth)]="dateMonth" [(dateYear)]="dateYear" [parentForm]="personalForm"
                         dateDayFormName="ddDate"
                         dateMonthFormName="mmDate" dateYearFormName="yyyyDate"
                         label="{{'dateOfBirthPersonal' | translate}}">
        </app-data-picker>

        <mat-error *ngIf="isRequiredField('mmDate') || isRequiredField('ddDate') || isRequiredField('yyyyDate')"
                   class="text-start">
          {{ 'dateOfBirthRequired' | translate }}
        </mat-error>

        <mat-error *ngIf="submitted && !isCorrectYear()" class="text-start">
          {{ 'yearIncorrect' | translate }}
        </mat-error>

        <mat-error *ngIf="submitted && isCorrectYear() && !isDate()" class="text-start">
          {{ 'dateIncorrect' | translate }}
        </mat-error>

        <mat-error *ngIf="submitted && isCorrectYear() && isDate() && !isCorrectAge()" class="text-start">
          {{ 'dateOfBirthIncorrect' | translate }}
        </mat-error>

        <mat-error *ngIf="isCorrectYear() && isDate() && isCashDOB()" class="text-start">
          {{ isSecondFolder ? ('cashDOBSecond' | translate) : ('cashDOB' | translate) }}
        </mat-error>

      </div>
    </section>

    <div class="w-lg-100"></div>

    <section class="data-field step-1 order-xl-0 col-xl-4">
      <div class="label">
        <div [innerHTML]="'nativeFirstName' | translate | translateCut:0 | safe:'html'"></div>
        <span class="small">{{ 'nativeFirstName' | translate | translateCut:1 }}</span>
      </div>
      <mat-form-field [floatLabel]="'always'" appearance="outline">
        <input (change)="onNativeFirstNameChanged()"
               formControlName="nativeFirstName" matInput
               name="nativeFirstName" oninput="this.value=this.value.replace(/[a-zA-Z]/g,'')">
        <mat-error *ngIf="isRequiredField('nativeFirstName')">
          {{ 'nativeFirstNameRequired' | translate }}
        </mat-error>
      </mat-form-field>
    </section>

    <section class="data-field step-1 order-xl-0 col-xl-4">
      <div class="label">
        <div [innerHTML]="'nativeLastName' | translate | translateCut:0 | safe:'html'"></div>
        <span class="small">{{ 'nativeLastName' | translate | translateCut:1 }}</span>
      </div>
      <mat-form-field [floatLabel]="'always'" appearance="outline">
        <input (change)="onNativeLastNameChanged()"
               formControlName="nativeLastName" matInput
               name="nativeLastName" oninput="this.value=this.value.replace(/[a-zA-Z]/g,'')">
        <mat-error *ngIf="isRequiredField('nativeLastName')">
          {{ 'nativeLastNameRequired' | translate }}
        </mat-error>
      </mat-form-field>
    </section>

    <section class="data-field step-2 order-xl-0 col-xl-4">
      <div [innerHTML]="'email' | translate | safe:'html'" class="label">
      </div>
      <mat-form-field [floatLabel]="'always'" appearance="outline">
        <input class="ltr-text u-text" formControlName="email" matInput name="email"
               oninput="this.value=this.value.replace(/[^a-zA-Z0-9|_.\-@\s]/g,'')">

        <mat-error *ngIf="isRequiredField('email')">
          {{ 'emailRequired' | translate }}
        </mat-error>

        <mat-error *ngIf="hasErrorField('email', 'pattern')">
          {{ 'emailNotValid' | translate }}
        </mat-error>

        <mat-error *ngIf="hasErrorField('email', 'forbidden')">
          {{ 'ForbiddenEmail' | translate }}
        </mat-error>
      </mat-form-field>
    </section>
    <div class="w-lg-100"></div>

    <section class="data-field step-2 order-xl-0 col-xl-4">
      <div [innerHTML]="'gender' | translate | safe:'html'" class="label">
      </div>

      <mat-form-field [floatLabel]="'always'" appearance="outline" class="select">
        <mat-select (selectionChange)="updateUser()" [translate]="'genderValue'"
                    formControlName="gender"
                    name="gender">
          <mat-option *ngFor="let gender of genderList" value="{{gender.statusValue}}">
            {{ gender.statusName | translate }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="isRequiredField('gender')">
          {{ 'genderRequired' | translate }}
        </mat-error>
      </mat-form-field>
    </section>

    <ng-container *ngIf="requiredPhone">
      <section class="data-field step-2 order-xl-0 col-xl-4">
        <div class="label">
          <div [innerHTML]="'phone' | translate | translateCut:0 | safe:'html'"></div>
          <span class="small">{{ 'phone' | translate | translateCut:1 }}</span>
        </div>

        <mat-form-field [floatLabel]="'always'" appearance="outline">
          <input formControlName="phone" matInput name="phone"
                 oninput="this.value=this.value.replace(/[^0-9\s]/g,'')">

          <mat-error *ngIf="isRequiredField('phone')">
            {{ 'phoneRequired' | translate }}
          </mat-error>

          <mat-error *ngIf="hasErrorField('phone', 'forbidden')">
            {{ 'ForbiddenPhone' | translate }}
          </mat-error>
        </mat-form-field>
      </section>
    </ng-container>

    <div class="w-lg-100 order-lg-3"></div>

    <section class="data-field step-3 order-xl-0 col-xl-4">
      <div [innerHTML]="'maritalStatus' | translate | safe:'html'" class="label">
      </div>

      <mat-form-field [floatLabel]="'always'" appearance="outline" class="select">
        <mat-select (selectionChange)="updateUser()"
                    formControlName="maritalStatus"
                    name="maritalstatus">
          <mat-option *ngFor="let marital of maritalStatusList" value="{{marital.statusValue}}">
            {{ marital.statusName | translate }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="isRequiredField('maritalStatus')">
          {{ 'maritalStatusRequired' | translate }}
        </mat-error>
      </mat-form-field>
    </section>

    <section class="data-field step-3 order-xl-0 col-xl-4">
      <div class="label">
        <div [innerHTML]="'NumberOfDependents' | translate | translateCut:0 | safe:'html'"></div>
        <span class="small">{{ 'NumberOfDependents' | translate | translateCut:1 }}</span>
      </div>

      <mat-form-field [floatLabel]="'always'" appearance="outline" class="select">
        <mat-select (selectionChange)="updateUser()"
                    formControlName="numberOfDependents" name="numberOfDependents">
          <mat-option *ngFor="let item of [].constructor(11); let i = index" [value]="i">
            {{ 'numberOfDependents_' + i | translate }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="isRequiredField('numberOfDependents')">
          {{ 'numberOfDependentsRequired' | translate }}
        </mat-error>
      </mat-form-field>
    </section>
  </div>
</form>
